const WarningBanner = ({ message }) => {
  return (
    <div
      className="rounded-3 p-3 mb-4 d-flex align-items-center gap-2"
      style={{
        backgroundColor: "#fff7ed",
        border: "1px solid #ffedd5",
        color: "#c2410c",
        fontSize: "14px",
        direction: "rtl",
      }}
    >
      <i
        className="ri-error-warning-fill flex-shrink-0"
        style={{ fontSize: "18px", color: "#ea580c" }}
      ></i>
      <span>{message}</span>
    </div>
  );
};

export default WarningBanner;
